isMatchingEndpointType